module.exports = __webpack_public_path__ + "static/media/facebook-ads.f491b133.png";